<template>
  <div>
    <vue-html2pdf :show-layout="false" :float-layout="true" :enable-download="false" :preview-modal="true"
      filename="hee hee" :pdf-quality="2" :manual-pagination="true" pdf-format="a4" pdf-orientation="landscape"
      pdf-content-width="297mm" ref="html2Pdf">
      <section slot="pdf-content">
        <div style="position: absolute; top:0; height: 210mm; width:297mm;">
          <b-img src="../diploma_background.png" style="height:210mm"></b-img>
        </div>
        <b-container style="font-family:'Great Vibes';position: relative;top:0;height: 210mm;">

          <b-row>
            <b-col style="font-size:45px; padding-top:50px; text-align:center;">
              Instituto Fueguino de Enseñanza Inglesa
            </b-col>
          </b-row>
          <b-row>
            <b-col style="font-weight:500;font-size:45px; margin-top:10px; color:#3e96d5; text-align:center;">
              - Informe Final -
            </b-col>
          </b-row>
          <b-row>
            <b-col
              style="font-weight:500;font-family:'Montserrat';color:#3e96d5;font-size:25px; text-align:center; margin-top:-10px">
              {{ curso }}
            </b-col>
          </b-row>
          <b-row>
            <b-col style="font-weight:500;font-size:75px; text-align:center;">
              {{ alumno }}
            </b-col>
          </b-row>

          <b-row style="font-weight:500;font-size:50px; text-align:center;height:40px">
            <b-col sm="2"></b-col>
            <b-col style="text-align:center">
              <table style="width:100%">
                <tr v-for="(v, k) in score" :key="k" style="line-height:55px;">
                  <td>{{ k }} {{ v }}</td>
                </tr>
              </table>
            </b-col>
            <b-col sm="2"></b-col>
          </b-row>

          <b-row>
            <b-col style="font-weight:500;font-size:30px; text-align:center;margin-top:140px">
              {{ comentario }}
            </b-col>
          </b-row>

        </b-container>
        <b-container style="position:absolute;bottom:60px">
          <b-row>
            <b-col sm="1"></b-col>
            <b-col sm="3" style="text-align:center">
              <b-img :src="supSignature" height="70px" style="margin-top:25px"></b-img><br>
              Prof. {{ modalPeriodScorebooks.course.x_2nd_signature_id[1] }}
            </b-col>
            <b-col sm="4" style="text-align:center;">
              <b-img src="../LogoIfei.png" width="100px"></b-img> <br>
              Río Grande , {{ period }} {{ year }}
            </b-col>
            <b-col sm="3" style="text-align:center">
              <b-img :src="teacherSignature" height="70px" style="margin-top:25px"></b-img><br>
              Prof. {{ modalPeriodScorebooks.teacher.x_name }}
            </b-col>
            <b-col sm="1"></b-col>
          </b-row>
        </b-container>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>

// import { FamiliesService } from '@/services/families.service'
import VueHtml2pdf from 'vue-html2pdf'
export default {
  name: 'Boletin',
  props: ['modalPeriodScorebooks'],
  components: {
    VueHtml2pdf
  },
  async created () {
    console.log(this.modalPeriodScorebooks)
  },
  computed: {
    curso: function () {
      return this.modalPeriodScorebooks.course.display_name
    },
    alumno: function () {
      return this.modalPeriodScorebooks.item.x_student_id[1]
    },
    supSignature: function () {
      return this.modalPeriodScorebooks.sup.x_signature
    },
    teacherSignature: function () {
      return this.modalPeriodScorebooks.teacher.x_signature
    },
    lastScore: function () {
      var lastScore = {}
      for (var i = 0; i < this.modalPeriodScorebooks.items.length; i++) {
        if (this.modalPeriodScorebooks.items[i].scorebook !== undefined) {
          lastScore = this.modalPeriodScorebooks.items[i].scorebook
        }
      }
      return lastScore
    },
    period: function () {
      var period = {}
      for (var i = 0; i < this.modalPeriodScorebooks.items.length; i++) {
        if (this.modalPeriodScorebooks.items[i].scorebook !== undefined) {
          period = this.modalPeriodScorebooks.items[i].x_name
        }
      }
      return period
    },
    year: function () {
      console.log(this.modalPeriodScorebooks)
      return this.modalPeriodScorebooks.class.x_year
    },
    score: function () {
      const lastScore = this.lastScore
      const score = {}

      for (const item in Object.keys(lastScore.score)) {
        const indx = Object.keys(lastScore.score)[item].charAt(0).toUpperCase() + Object.keys(lastScore.score)[item].slice(1)
        score[indx] = lastScore.score[Object.keys(lastScore.score)[item]]
      }
      return score
    },
    comentario: function () {
      let comment = ''
      const desaprobados = []
      for (const item in this.score) {
        console.log(item, this.score[item])
        if (this.score[item] < this.modalPeriodScorebooks.course.x_pass_score) {
          desaprobados.push(item)
        }
      }
      if (desaprobados.length === 0) {
        comment = 'Ha aprobado ' + this.curso
        if (this.modalPeriodScorebooks.course.x_next_course_id !== false) {
          comment = comment + ' y es promovido/a a ' + this.modalPeriodScorebooks.course.x_next_course_id[1] + '.'
        } else {
          comment = comment + ' completando el plan de estudios.'
        }
      } else {
        comment = 'Debe rendir '
        if (desaprobados.length === 1) {
          comment = comment + ' el examen '
        } else {
          comment = comment + ' los examenes '
        }
        for (let i = 0; i < desaprobados.length; i++) {
          if (i === desaprobados.length - 1 && i > 0) {
            comment = comment + ' y '
          } else if (i > 0) {
            comment = comment + ', '
          }
          comment = comment + desaprobados[i]
        }
        comment = comment + ' en '
        if (this.period === 'Diciembre') {
          comment = comment + ' Marzo.'
        } else {
          comment = comment + ' Febrero.'
        }
      }
      return comment
    }
  },
  async mounted () {
    this.$refs.html2Pdf.generatePdf()
  }
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'Great Vibes';
  src: local('Great Vibes'), url('../assets/fonts/GreatVibes-Regular.ttf') format('truetype'),
}

@font-face {
  font-family: 'Montserrat';
  src: local('Montserrat'), url('../assets/fonts/Montserrat-VariableFont_wght.ttf') format('truetype'),
}

@font-face {
  font-family: 'Tangerine';
  src: local('Tangerine'), url('../assets/fonts/Tangerine-Regular.ttf') format('truetype'),
}

.title {
  font-size: 25px;
}

.informe-proceso {
  font-size: 15px;
  text-align: end;
}

.divider,
.divider-blue {
  height: 2px;
  border: 1px solid #b4b7bd;
}

.divider-blue {
  border: 1px solid #7dcaf6;
}

.name {
  font-size: 20px;
  color: black;
}

.name-items {
  color: #7dcaf6;
  font-size: 14px;
  line-height: 15px;
  font-weight: bold;
}

.name-items-data {
  color: black;
  font-size: 18px;
  line-height: 21px;
}

.test {
  border-bottom: 1px solid #b4b7bd;
}

.text-center {
  text-align: center;
  font-size: 18px;
  font-weight: 500;
}

.table-titles,
.footer-title {
  color: #67696d;
  font-weight: 300;
  font-size: 14px;
}

.footer-title {
  font-size: 12px;
}

.firmas-container {
  display: flex;
  position: absolute;
  bottom: 0px;
  justify-content: space-around;
  align-items: center;
  width: 60%;
  margin: 10px auto;
}
</style>
